<template>
  <teleport to="body">
    <div v-if="modelValue">
      <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true" @click.self="close">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mb-0">{{ title }}</h5>
              <button type="button" class="close" aria-label="Close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <template v-if="kindUpper === 'MA'">
                <div class="form-group row align-items-center">
                  <label class="col-5 col-form-label text-muted text-sm">Period</label>
                  <div class="col-7">
                    <input type="number" class="form-control form-control-sm" v-model.number="ma.period"
                      :min="schemaResolved.ma.period.min" :max="schemaResolved.ma.period.max"
                      :step="schemaResolved.ma.period.step" />
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <label class="col-5 col-form-label text-muted text-sm">Field</label>
                  <div class="col-7">
                    <select class="form-control form-control-sm" v-model="ma.field">
                      <option v-for="f in schemaResolved.ma.fields" :key="f.value" :value="f.value">
                        {{ f.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <label class="col-5 col-form-label text-muted text-sm">Type</label>
                  <div class="col-7">
                    <select class="form-control form-control-sm" v-model="ma.type">
                      <option value="Simple">Simple</option>
                      <option value="Exponential">Exponential</option>
                      <option value="Triangular">Triangular</option>
                      <option value="Vidya">Vidya</option>
                      <option value="weighted">Weighted</option>
                      <option value="welles wilder">Welles Wilder</option>
                      <option value="variable">Variable</option>
                      <option value="Time Series">Time Series</option>
                      <option value="Hull">Hull</option>
                      <option value="Double Exponential">Double Exponential</option>
                      <option value="Triple Exponential">Triple Exponential</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <label class="col-5 col-form-label text-muted text-sm">Offset</label>
                  <div class="col-7">
                    <input type="number" class="form-control form-control-sm" v-model.number="ma.offset" />
                  </div>
                </div>
                <hr class="mb-2" />
                <div class="form-group row align-items-center">
                  <label class="col-5 col-form-label text-muted text-sm">MA</label>
                  <div class="col-7 d-flex justify-content-end">
                    <input type="color" v-model="ma.color" />
                  </div>
                </div>
                <hr class="mt-2 mb-1" />
                <div class="form-group row align-items-center">
                  <label class="col-5 col-form-label text-muted text-sm">Panel</label>
                  <div class="col-7">
                    <select class="form-control form-control-sm" v-model="ma.panel">
                      <option v-for="p in schemaResolved.panels" :key="p.value" :value="p.value">
                        {{ p.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row align-items-center mb-0">
                  <label class="col-7 col-form-label text-muted text-sm">Show as Underlay</label>
                  <div class="col-5">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="maUnderlay" v-model="ma.underlay" />
                      <label class="custom-control-label" for="maUnderlay"></label>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary btn-block" @click="done">DONE</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show"></div>
    </div>
  </teleport>
</template>
<script>
   const chart_marking={
    ma_line:"#ff0000"
  };
export default {
  name: "StudySettingsModal",
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: "Settings" },
    kind: { type: String, default: "" },
    settings: { type: Object, required: true },
    schema: { type: Object, default: () => ({}) },
  },
  emits: ["update:modelValue", "apply", "close"],

  data() {
    return {
      generic: { panel: "auto", calcParams: [] },
      ma: {
        period: 50,
        field: "close",
        type: "Simple",
        offset: 0,
        color: chart_marking.ma_line,
        panel: "auto",
        underlay: false,
      },
      escHandler: null,
    };
  },
  computed: {
    kindUpper() {
      return String(this.kind || "").toUpperCase();
    },
    schemaResolved() {
      const defaults = {
        panels: [
          { value: "auto", label: "Auto" },
          { value: "overlay", label: "Overlay (Main chart)" },
          { value: "pane", label: "Separate pane" },
        ],
        ma: {
          period: { min: 1, max: 1000, step: 1 },
          fields: [
            { value: "close", label: "Close" },
            { value: "open", label: "Open" },
            { value: "high", label: "High" },
            { value: "low", label: "Low" },
            { value: "hl2", label: "hl/2" },
            { value: "hlc3", label: "hlc/3" },
            { value: "hlcc4", label: "hlcc/4" },
            { value: "ohlc4", label: "ohlc/4" },
          ],
        },
      };
      const merged = {
        ...defaults,
        ...(this.schema || {}),
        ma: {
          ...defaults.ma,
          ...((this.schema || {}).ma || {}),
        },
      };
      merged.panels = Array.isArray(merged.panels) ? merged.panels : defaults.panels;
      merged.ma.fields = Array.isArray(merged.ma.fields) ? merged.ma.fields : defaults.ma.fields;
      return merged;
    },
  },
  mounted() {
    this.initFromSettings();
  },
  beforeUnmount() {
    this.removeEscListener();
  },
  methods: {
    addEscListener() {
      if (this.escHandler) return;
      this.escHandler = (e) => e.key === "Escape" && this.close();
      window.addEventListener("keydown", this.escHandler);
    },
    removeEscListener() {
      if (!this.escHandler) return;
      window.removeEventListener("keydown", this.escHandler);
      this.escHandler = null;
    },
    initFromSettings() {
      const v = this.settings || {};
      const extra = v.extra || {};
      this.generic.panel = v.panel ?? "auto";
      this.generic.calcParams = Array.isArray(v.calcParams) ? [...v.calcParams] : [];
      this.ma.panel = v.panel ?? "auto";
      this.ma.period = Number(this.generic.calcParams?.[0] ?? extra.period ?? 50);
      this.ma.field = String(extra.field ?? "close").toLowerCase();
      this.ma.type = extra.type ?? "Simple";
      this.ma.offset = Number(extra.offset ?? 0);
      const styleColor =
        v?.style?.line?.color ||
        v?.style?.color ||
        v?.styles?.line?.color ||
        v?.styles?.color ||
        null;
      this.ma.color = styleColor || extra.color || chart_marking.ma_line;
      this.ma.underlay = !!extra.underlay;
      this.addEscListener();
    },
    close() {
      this.removeEscListener();
      this.$emit("update:modelValue", false);
      this.$emit("close");
    },
    done() {
      if (this.kindUpper === "MA") {
        this.$emit("apply", {
          panel: this.ma.panel,
          calcParams: [Number(this.ma.period)],
          extra: {
            field: this.ma.field,
            type: this.ma.type,
            offset: Number(this.ma.offset || 0),
            underlay: !!this.ma.underlay,
          },
          style: { line: { color: this.ma.color } },
        });
      } else {
        this.$emit("apply", {
          panel: this.generic.panel,
          calcParams: [...this.generic.calcParams],
          extra: this.settings?.extra || {},
          style: this.settings?.style || this.settings?.styles || {},
        });
      }
      this.close();
    },
  },
};
</script>
